import React, { PureComponent } from 'react';
import './WidgetMapaPrediccio.css';
import PropTypes from 'prop-types';
import { translate } from '../../utils/translations';
import { dayAfterTomorrow, dayNavColor } from '../../utils/utils';
import Header from '../../partials/Header/Header';
import logo from '../../img/logo.png';
import Nav from '../../partials/Nav/Nav';
import DayNav from '../../partials/DayNav/DayNav';
import { GeneralPrediction } from '../../partials/GeneralPrediction/GeneralPrediction';
import MorningAfternoonNav from '../../partials/MorningAfternoonNav';
import { debounce } from '../../utils/utils';
import { WIDGET_MARGIN_BOTTOM } from '../../utils/globals';

const WIDGET_CONTENT_MARGIN_BOTTOM = { preview: 70, iframe: 128 };

export class WidgetMapaPrediccio extends PureComponent {
    state = {
        day: 0,
        timeOfDay: 'both', // both, morning or afternoon
        isFlexWrapped: false,
        zoom: 0, // when the view has only one map we want to know the current zoom in ordrer to have a smooth morning/afternoon transition
    };

    static propTypes = {
        config: PropTypes.shape({
            language: PropTypes.string,
            target: PropTypes.string,
        }),
        data: PropTypes.shape({
            comarques: PropTypes.arrayOf(
                PropTypes.shape({
                    mati: PropTypes.shape({
                        calamarsa: PropTypes.array,
                        cel: PropTypes.array,
                        precipitacio: PropTypes.array,
                    }),
                    maximes: PropTypes.arrayOf(
                        PropTypes.shape({
                            idComarca: PropTypes.number,
                            temperatura: PropTypes.number,
                        })
                    ),
                    minimes: PropTypes.arrayOf(
                        PropTypes.shape({
                            idComarca: PropTypes.number,
                            temperatura: PropTypes.number,
                        })
                    ),
                    tarda: PropTypes.shape({
                        calamarsa: PropTypes.array,
                        cel: PropTypes.array,
                        precipitacio: PropTypes.array,
                    }),
                })
            ),
            maps: PropTypes.arrayOf(
                PropTypes.shape({
                    mati: PropTypes.shape({
                        simbols: PropTypes.shape({
                            estatDelCel: PropTypes.array,
                            estatDelMar: PropTypes.array,
                            vent: PropTypes.array,
                        }),
                        tendencies: PropTypes.array,
                    }),
                    tarda: PropTypes.shape({
                        simbols: PropTypes.shape({
                            estatDelCel: PropTypes.array,
                            estatDelMar: PropTypes.array,
                            vent: PropTypes.array,
                        }),
                        tendencies: PropTypes.array,
                    }),
                    variables: PropTypes.shape({
                        estatDelCel: PropTypes.string,
                        precipitacions: PropTypes.string,
                        temperatures: PropTypes.string,
                        vent: PropTypes.string,
                        visibilitat: PropTypes.string,
                    }),
                })
            ),
        }),
        days: PropTypes.number,
        preview: PropTypes.bool,
        widgetDate: PropTypes.string,
    };

    render() {
        const { day, timeOfDay, isFlexWrapped, zoom } = this.state;
        const { preview, config, widgetDate, days, data } = this.props;
        const { color, language, target } = config;
        const { comarques } = data;

        return (
            <div
                className="WidgetMapaPrediccio mc-widget"
                style={{
                    width: !preview ? '100%' : null,
                    height: !preview
                        ? `calc(100% - ${WIDGET_MARGIN_BOTTOM}px)`
                        : null,
                }}
            >
                <Header color={color} logo={logo} target={target} />
                <div
                    className="mc-widget-wrapper"
                    style={{ height: 'calc(100% - 38px)' }}
                >
                    <Nav
                        alternativeTitle={translate(
                            language,
                            'prediccio_title'
                        )}
                        language={language}
                        widgetDate={widgetDate}
                        target={target}
                    />
                    <DayNav
                        numberOfDays={days}
                        dayAfterTomorrow={dayAfterTomorrow(language, 'long')}
                        currentDay={day}
                        dayNavigation={this.dayNavigation}
                        color={dayNavColor(color)}
                        language={language}
                    />
                    {timeOfDay !== 'both' && (
                        <MorningAfternoonNav
                            currentTime={timeOfDay}
                            timeNavigation={this.timeNavigation}
                            color={dayNavColor(color)}
                            language={language}
                        />
                    )}
                    {data === {} || !data.map || !comarques[0].mati ? (
                        <p>{translate(language, 'no_data')}</p>
                    ) : (
                        <div
                            className={
                                !isFlexWrapped
                                    ? 'mc-widget-content'
                                    : timeOfDay === 'both'
                                        ? 'mc-widget-content flex-wrapped'
                                        : 'mc-widget-content flex-wrapped one-map'
                            }
                            style={{
                                height: preview
                                    ? `calc(100% - ${
                                          WIDGET_CONTENT_MARGIN_BOTTOM.preview
                                      }px)`
                                    : `calc(100vh - ${
                                          WIDGET_CONTENT_MARGIN_BOTTOM.iframe
                                      }px)`,
                                // eslint-disable-next-line
                                height: preview
                                    ? `calc(100% - ${
                                          WIDGET_CONTENT_MARGIN_BOTTOM.preview
                                      }px)`
                                    : `calc(100vh - ${
                                          WIDGET_CONTENT_MARGIN_BOTTOM.iframe
                                      }px)`,
                            }}
                        >
                            {(timeOfDay === 'morning' ||
                                timeOfDay === 'both') &&
                                data.map[day].mati && (
                                    <div className="mati">
                                        {timeOfDay === 'both' && (
                                            <h3>
                                                {translate(language, 'morning')}
                                            </h3>
                                        )}
                                        {comarques[day].mati && (
                                            <GeneralPrediction
                                                mapId="map1"
                                                data={data.map[day].mati}
                                                comarquesCel={
                                                    comarques[day].mati.cel
                                                }
                                                comarquesPrecipitacio={
                                                    comarques[day].mati
                                                        .precipitacio
                                                }
                                                comarquesTempMax={
                                                    comarques[day].maximes
                                                }
                                                comarquesTempMin={
                                                    comarques[day].minimes
                                                }
                                                day={day}
                                                color={color}
                                                preview={preview}
                                                isFlexWrapped={isFlexWrapped}
                                                setParentZoomState={
                                                    this.setZoom
                                                }
                                                zoom={zoom}
                                            />
                                        )}
                                    </div>
                                )}
                            {(timeOfDay === 'afternoon' ||
                                timeOfDay === 'both') && (
                                <div className="tarda">
                                    {timeOfDay === 'both' && (
                                        <h3>
                                            {translate(language, 'afternoon')}
                                        </h3>
                                    )}
                                    {comarques[day].tarda && (
                                        <GeneralPrediction
                                            mapId="map2"
                                            data={data.map[day].tarda}
                                            comarquesCel={
                                                comarques[day].tarda.cel
                                            }
                                            comarquesPrecipitacio={
                                                comarques[day].tarda
                                                    .precipitacio
                                            }
                                            comarquesTempMax={
                                                comarques[day].maximes
                                            }
                                            comarquesTempMin={
                                                comarques[day].minimes
                                            }
                                            day={day}
                                            color={color}
                                            preview={preview}
                                            isFlexWrapped={isFlexWrapped}
                                            setParentZoomState={this.setZoom}
                                            zoom={zoom}
                                        />
                                    )}
                                </div>
                            )}
                        </div>
                    )}
                </div>
            </div>
        );
    }

    componentDidMount() {
        window.addEventListener('resize', () => {
            this.flexBehaviour();
        });
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handler);
    }

    componentDidUpdate() {
        if (this.state.timeOfDay !== 'afternoon') {
            this.flexBehaviour();
        }
    }

    dayNavigation = day => {
        this.setState({ day });
    };

    timeNavigation = timeOfDay => {
        this.setState({ timeOfDay });
    };

    flexBehaviour = debounce(() => {
        if (this.props.preview) return;
        const w = window.innerWidth;
        const h = window.innerHeight;

        const proportionalWidth = w / h;
        const proportionalHeight = h / w;

        const widthThreshold = 1.4;
        const heightThreshold = 2.2;

        let isFlexWrapped = false; // 100% width
        let timeOfDay = 'both';

        // Container is almost a Square
        if (
            proportionalWidth < widthThreshold &&
            proportionalHeight < heightThreshold
        ) {
            timeOfDay =
                this.state.timeOfDay === 'afternoon' ? 'afternoon' : 'morning';
            isFlexWrapped = true;
        }

        // Width almost double than Height
        if (proportionalWidth > widthThreshold) {
            isFlexWrapped = false;
            timeOfDay = 'both';
        }

        // Height double than Width
        if (proportionalHeight > heightThreshold) {
            isFlexWrapped = true;
            timeOfDay = 'both';
        }

        this.setState({ isFlexWrapped, timeOfDay });
    });

    setZoom = zoom => this.setState({ zoom });
}



// WEBPACK FOOTER //
// ./src/widgets/MapaPrediccio/WidgetMapaPrediccio.js